import MoveInput from "../Components/MoveInput/MoveInput";
import { Icon_Close, Icon_Trash, Icon_ContentCopy } from "../../../BP2Components/Icons/icons";

import "./ElementSettingsSimple.less";
import EditableField from "../EditableField/EditableField";

const ElementSettingsSimple = ({ item, onAction, onClose }) => {
   return (
      <div className="element">
         <div className="element-close" onClick={onClose}>
            <Icon_Close fill="none" stroke="#64748B" />
         </div>
         {item.type === "section" ? (
            <div>
               <div className="element-label">
                  <span className="label">Nazwa:</span>

                  <EditableField
                     fieldValue={item.label}
                     onAccept={(value) => onAction("edit", { label: value })}
                  />
               </div>
            </div>
         ) : null}
         <div className="form-edit-input-actions">
            <span className="label">Akcje: </span>

            <MoveInput onMove={(direction) => onAction("move", { direction })} />

            <div className="form-builder-input-actions-common">
               <button
                  className="form-builder-duplicate-input"
                  onClick={() => {
                     onAction("duplicate");
                  }}
               >
                  <Icon_ContentCopy />
               </button>

               <button
                  className="form-delete-input"
                  onClick={() => {
                     onAction("delete");
                     onClose();
                  }}
               >
                  <Icon_Trash />
               </button>
            </div>
         </div>
      </div>
   );
};

export default ElementSettingsSimple;
